module.exports = __webpack_public_path__ + "static/8-3de1f2ad1b074bf83f1c80f079252171.png";